<template>
  <div v-if="visible" class="fixed inset-0 flex items-center justify-center bg-black/50 z-50">
    <div class="bg-white rounded shadow-lg p-6">
      <h2 class="text-lg font-bold mb-4">{{message}}</h2>
	  <div class="confirmtablewrapper">
		<DataTable :columns="props.colsitems" :data="props.items" :enableediting="false"/>
	  </div>
      <div class="flex justify-end">
        <button @click="confirm" class="px-3 py-1 bg-blue-500 text-white rounded">
          Confirm
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import DataTable from '../timintables/DataTable.vue'


const props = defineProps({
  message: {type: String, default: () => "Confirm"},
  colsitems: {type: Object, default: () => {}},
  items: { type: Array, default: () => [] }
})

const visible = ref(false)
let resolver = null

function open() {
  visible.value = true
  return new Promise((resolve) => {
    resolver = resolve
  })
}

function confirm() {
  visible.value = false
  resolver?.(true)
}

defineExpose({ open })
</script>
<style>
table, th, td {
  border: 1px solid black;
  border-collapse: collapse;
}

th, td {
padding-left: 3px !important;
width: 50px !important;
}

.confirmtablewrapper {
	overflow-y: auto;  
}
</style>
